var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.38 82.9401H28.06L40.9 15.1801H54.54L67.38 82.9401Z",
    fill: "#FF931E",
    stroke: "#FF931E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.01 33.4701H37.44L35.61 43.1101H59.83L58.01 33.4701Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.51 64.7301H63.93L62.1 55.0801H33.34L31.51 64.7301Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2 81.99H13.25V88.53H82.2V81.99Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.27 35.4C75.27 35.4 75.27 23.43 87.24 23.43C87.24 23.43 75.27 23.43 75.27 11.46C75.27 11.46 75.27 23.43 63.3 23.43C63.3 23.43 75.27 23.43 75.27 35.4Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.74 64.34C18.74 64.34 18.74 58.35 24.73 58.35C24.73 58.35 18.74 58.35 18.74 52.36C18.74 52.36 18.74 58.35 12.75 58.35C12.75 58.35 18.74 58.35 18.74 64.34V64.34Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.799ab8f078212a8e7211c8c555f9b44a.svg";
export { ForwardRef as ReactComponent };